<div class="used-workingarea-item" [ngClass]="{'selected': selected}" *ngIf="station">
    <sc-flex [fitHeight]="true" [vertical]="true" [stretchContent]="true">
        <div>
            <sc-flex >
                <div class="station-name" [ngClass]="{'exceeded':transport.processing.processingDurationExceeded}">{{station.name}}</div>
                <sc-content-spacer [grow]="true"></sc-content-spacer>
                <div class="duration" [ngClass]="{'critical':transport.processing.processingDurationCritical}"><sc-icon iconClass="fa-arrow-right" *ngIf="transport.masterdata.preloading"></sc-icon>
                    {{transport.processing.processingTime}} <span *ngIf="!transport.masterdata.preloading"></span></div>
            </sc-flex>
        </div>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-flex class="identity" [centered]="true">
            <app-transport-scope-icon [scope]="transport.scope"></app-transport-scope-icon>
            <sc-content-spacer></sc-content-spacer>
            <div class="identity-label">{{transport.identifyingNumberplate}}</div>
        </sc-flex>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <div class="carrier">
            {{transport.masterdata.carrier}}
        </div>
        <sc-content-spacer [vertical]="true" [half]="true"></sc-content-spacer>
        <sc-flex [centered]="true">
            <div class="status-icon" *ngIf="transport.masterdata.important">
              <sc-icon iconClass="fa-exclamation"></sc-icon>
            </div>
            <div class="status-icon" *ngIf="transport.masterdata.dangerousGoods">
                <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
            </div>
            <div class="status-icon" *ngIf="transport.processing.pendingTaskState !== TransportTaskStatus.NONE">
                <app-task-state-icon [state]="transport.processing.pendingTaskState"></app-task-state-icon>
            </div>
            <div class="status-icon" *ngIf="transport.masterdata.urgent">
                <sc-icon iconClass="fa-truck-fast"></sc-icon>
            </div>
            <div class="status-icon" *ngIf="transport.processing.inUmbrueckung">
                <sc-icon iconClass="fa-random"></sc-icon>
            </div>
            <div class="status-icon" *ngIf="transport.processing.waitingForPulling">
                <sc-icon iconClass="fa-circle-pause"></sc-icon>
            </div>
            <div class="status-icon" *ngIf="station.stationUsage.ongoingMovementFromStation || station.stationUsage.ongoingMovementToStation">
                <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
            </div>
        </sc-flex>
    </sc-flex>
</div>
